<template>
  <div>
    <form v-if="!done" @submit.prevent="onSubmit()">
      <fieldset>
        <div class="line">
          <label for="register-email">Sähköposti:</label>
          <input @input="onEmailInput" @blur="validateEmail" v-model="email" type="email" name="email" id="register-email" autocomplete="email">
          <span v-if="error.emailInvalid" class="error">Sähköposti virheellinen</span>
        </div>
        <div class="line">
          <label for="register-name">Nimi:</label>
          <input @input="onNameInput" @blur="validateName" v-model="name" type="text" name="name" id="register-name" autocomplete="name">
          <span v-if="error.nameEmpty" class="error">Nimi kenttä on pakollinen</span>
        </div>
        <div class="line">
          <label for="register-password">Salasana:</label>
          <input @input="onPasswordInput" @blur="validatePassword" v-model="password" type="password" name="password" id="register-password" autocomplete="new-password">
          <span v-if="error.passwordTooShort" class="error">Salasanan tulee olla vähintään 8 merkkiä pitkä</span>
        </div>
        <div class="line">
          <label for="register-repeat-password">Salasana uudelleen:</label>
          <input @input="onPassword2Input" @blur="validatePassword2" v-model="password2" type="password" name="password2" id="register-repeat-password" autocomplete="new-password">
          <span v-if="error.passwordMatch" class="error">Salasanat eivät täsmää!</span>
        </div>
        <div v-if="!codeParam" class="line">
          <label for="register-code">Rekisteröitymis-koodi:</label>
          <input v-model="code" type="text" name="code" id="register-code">
        </div>
        <div v-if="!loading" class="line">
          <button type="submit">Luo tili</button>
        </div>
        <div v-else class="line done">
          <p>Rekisteröidään...</p>
        </div>
      </fieldset>
    </form>
    <div v-if="failed" class="line error">Rekisteröityminen epäonnistui - {{errorMessage}}</div>
    <div v-if="done" class="line">
      <h3 class="done">Rekisteröityminen onnistui.</h3>
      <p>Saat hetken kuluttua vahvistusviestin sähköpostiisi.</p>
      <p>(Joissakin palveluissa vahvistusviesti voi päätyä roskapostikansioon.)</p>
      <br>
      <p>Jos vahvistussähköposti ei saavu kymmenessä minuutissa, lähetä koodi uudelleen: </p>
      <a v-if="!resending" class="link" @click="resendCode()">Lähetä vahvistusviesti uudelleen</a>
      <a v-if="resending">Vahvistusviesti lähetettiin uudelleen</a>
    </div>
  </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';
import Auth from './../store/modules/auth/types';

const PASSWORD_MIN_LENGTH = 8;
const EMAIL_MIN_LENGTH = 4;

export default {
  name: 'RegisterView',
  data () {
    return {
      email: '',
      name: '',
      password: '',
      password2: '',
      error: {
        passwordTooShort: false,
        passwordMatch: false,
        emailInvalid: false,
        nameEmpty: false
      },
      codeParam: this.$route.query.code,
      code: '',
      errors: false,
      errorMessage: '',
      resending: false,
    }
  },
  computed: {
    loading () {
      return this.getRegisterStatus() === 'pending'
    },
    done () {
      return this.getRegisterStatus() === 'done'
    },
    failed () {
      return this.getRegisterStatus() === 'failed'
    },
    ...mapGetters('Auth', [Auth.getters.GET_REGISTER_STATUS])
  },
  methods: {
    onEmailInput () {
      if (this.error.emailInvalid) {
        this.validateEmail();
      }
    },
    onNameInput () {
      if (this.error.nameEmpty) {
        this.validateName();
      }
    },
    onPasswordInput () {
      console.log('onPasswordInput');
      if (this.error.passwordTooShort) {
        this.validatePassword();
      }
    },
    onPassword2Input () {
      console.log('onPassword2Input');
      if (this.error.passwordMatch) {
        this.validatePassword();
      }
    },
    validatePassword () {
      this.error.passwordTooShort = this.password.length < PASSWORD_MIN_LENGTH;
    },
    validatePassword2 () {
      this.error.passwordMatch = this.password !== this.password2;
    },
    validateEmail () {
      this.error.emailInvalid = this.email.length < EMAIL_MIN_LENGTH;
    },
    validateName () {
      this.error.nameEmpty = this.name.length < 1;
    },
    checkErrors () {
      this.validatePassword();
      this.validateEmail();
      this.validateName();
    },
    hasErrors () {
      console.log('hasErrors');

      for (let e in this.error) {
        if (this.error[e]) {
          console.log(e);
          return true;
        }
      }
      return false;
    },
    resendCode () {
      this.resending = true;
      this.resendVerification(this.email);
    },
    onSubmit () {
      this.checkErrors();
      if (this.hasErrors()) {
        return;
      }
      console.log('onSubmit');
      const email = this.email;
      const name = this.name;
      const password = this.password;
      const code = this.codeParam || this.code;

      this.registerUser({email, name, password, code}).then(res => {
        console.log('Register success', res);
        this.codeUsed(code);
      }).catch(err => {
        console.log('Register error', err);
        console.log('Register error', err.code);
        if (err.code === 'UsernameExistsException') {
          this.errorMessage = 'Sähköposti on jo käytössä';
        } else if (err.code === 'UserLambdaValidationException') {
          if (err.message.includes('CODE_NOT_VALID')) {
            this.errorMessage = 'Rekisteröintikoodi ei kelpaa.'
          } else if (err.message.includes('CODE_EXPIRED')) {
            this.errorMessage = 'Rekisteröintikoodi on vanhentunut.'
          }
        }
      })
    },
    ...mapActions('Auth', [
      Auth.actions.REGISTER_USER,
      Auth.actions.CODE_USED,
      Auth.actions.RESEND_VERIFICATION,
    ])
  }
}
</script>

<style lang="scss" scoped>
  @import 'src/color.scss';
  @import 'src/values.scss';

  form {
    text-align: left;
    width: 80%;
    max-width: 400px;
    margin: 1em auto;
  }

  fieldset {
    border: none;
  }

  input, label {
    box-sizing: border-box;
    cursor: pointer;
  }

  input {
    display: block;
    width: 100%;
    padding: 0.4em 0.3em;
    font-weight: bold;
  }

  .line {
    margin-bottom: 1em;
  }

  label {
    width: 100%;
    display: inline-block;
    margin-bottom: 0.4em;
    font-weight: bold;
  }

  button {
    padding: 0.6em 0.8em;
    //border-radius: 0.5em;
    //background: linear-gradient($secondary-light, $secondary);
    background: $secondary;
    color: white;
    display: block;
    margin: 0.2em auto;
    font-size: 110%;
    font-weight: bold;

    border: none;

    transition: $transition-time all;
    &:hover,&:active,&:focus {
      background-color: $secondary-dark;
    }
  }

  .done {
    margin: 2em 0;
    padding: 0 1em;
  }

  .link {
    color: blue;
    cursor: pointer;
  }

</style>



// WEBPACK FOOTER //
// src/components/RegisterView.vue